import { isPlatformBrowser } from "@angular/common";
import { Inject, Injectable, PLATFORM_ID } from "@angular/core";
import * as Sentry from "@sentry/angular";
export enum LoggedInUserKeys {
  LOGGED_IN_USER = "loggedInUser",
  BASIC_DETAILS = "basicDetails",
  USER_DETAILS = "userDetails",
  SCHEDULE_DETAILS = "schedule details",
  DRIVE_DETAILS = "driveDetails",
  SECTION_TIMER="sectionTimer"
}
@Injectable({
  providedIn: "root",
})
export class LoggedInUserService {
  constructor(@Inject(PLATFORM_ID) private platformId: object) { }

  getLoggedInUser(key: LoggedInUserKeys) {
    const loggedIn = isPlatformBrowser(this.platformId)
      ? JSON.parse(localStorage.getItem(!key ? LoggedInUserKeys.LOGGED_IN_USER : key))
      : "";
    return loggedIn;
  }

  setLoggedInUser(key: LoggedInUserKeys, localStorageData) {
    localStorage.setItem(key ? key : LoggedInUserKeys.LOGGED_IN_USER, JSON.stringify(localStorageData));
  }
  removeLoggedInUser(key: LoggedInUserKeys) {
    localStorage.removeItem(key ? key : '');
  }
  clearEntireStorage() {
    try {
      Sentry.setUser(null);
    } catch {
      // Never let telemetry cleanup block a logout.
    }
    localStorage.clear();
    sessionStorage.clear();
  }
}
